<template>
	<Col @click.native="onClick" class="icon-container flex-centerize" :class="{ selected: isSelected }">
		<v-img class="image-container" :title="icon.name" :alt="icon.name" aspect-ratio="1/1" :src="imgSrc" :width="size" />
	</Col>
</template>
<script>
export default {
	name: 'NotificationIconButton',
	props: {
		icon: { type: Object },
		size: { type: Number, default: 25 },
		isSelected: { type: Boolean, default: false },
	},
	computed: {
		imgSrc() {
			return this.icon.localSrc || this.icon.url;
		},
	},
	methods: {
		onClick() {
			this.$emit('choose-mdi-icon', this.icon.name);
			this.$emit('close-menu');
		},
	},
};
</script>
<style scoped lang="scss">
$icon-size: 25px;
.icon-container {
	cursor: pointer;
	transition: 0.3s;
	border-radius: 5px;
	min-width: $icon-size;
	max-width: $icon-size;
	min-height: $icon-size;
	max-height: $icon-size;
	.image-container {
		border-radius: 5px;
	}
	&:hover {
		cursor: pointer;
		transition: 0.1s;
		background: #bfbfc9;
		box-shadow: 0px 3px 6px var(--shadow-color);
	}
	&:active {
		transition: 0.1s;
		filter: brightness(0.9);
	}
	&.selected {
		min-width: calc(#{$icon-size} + 4px);
		max-width: calc(#{$icon-size} + 4px);
		min-height: calc(#{$icon-size} + 4px);
		max-height: calc(#{$icon-size} + 4px);
		transition: 0.3s;
		border-radius: 7px;
		border: 2px solid #6092f0;
		.image-container {
			border-radius: 7px;
		}
	}
}
</style>
